export const Colors = {
  primary: '#B82025',
  secondary: '#303261',
  tertiary: '',

  screen_1: '#fff',
  screen_2: '',
  screen_3: '',

  modal_1: '',

  txt_1: '#212121',
  txt_2: '#575757',
  txt_3: '#fff',
  txt_4: '',
  txt_5: '',

  field_1: '',
  field_2: '',

  button_1: '',
  button_2: '',
  button_disable: '',

  icon_1: '',
  icon_2: '',
  icon_3: '',

  shadow_1: 'rgba(0, 0, 0, 0.25)',

  separator_1: '#EBEBEB',

  success: '',
  fail: '#B91718',

  indicator: '#17EFB0',
  balck_33: '#ABABAB',
};

export const colorPalette = {
  primary: '#F34F42',
  primaryLighter: '#F4665A',
  primaryLighter2: '#F78B83',
  secondary: '#B91618',
  secondaryLighter: '#C23436',
  secondaryLighter2: '#D16667',
  whiteGrey0: '#FFFFFF',
  grey0_5: '#F7F7F7',
  grey1: '#EAEAEA',
  grey1_5: '#DCDCDC',
  grey2: '#CFCFCF',
  grey3: '#C1C1C1',
  grey4: '#A6A6A6',
  grey5: '#8B8B8B',
  grey6: '#707070',
  grey7: '#5A5A5A',
  grey8: '#434343',
  grey8_5: '#2D2D2D',
  grey9: '#222222',
  grey9_5: '#161616',
  grey10: '#0B0B0B',
  grey200: '#CACACD',
  purple0: '#F5F7FF',
  purple100: '#EDF0FD',
  purple200: '#D9DFF9',
  purple300: '#B8C3F3',
  purple400: '#5A5A5A',
  purple500: '#6077DE',
  purple600: '#3B56CE',
  purple700: '#223EB9',
  purple800: '#142EA2',
  errorMain: '#F74B4A',
  errorDarker: '#F2302F',
  errorLighter: '#F87878',
  infoMain: '#2BBEF2',
  infoDarker: '#1B93C0',
  infoLighter: '#BFEEFF',
  successMain: '#61D215',
  successDarker: '#51A915',
  successLighter: '#B7F28F',
  warningMain: '#FF9D00',
  warningDarker: '#E58D00',
  warningLighter: '#FFBA4B',
  eerieBlack: '#181819',
  darkCharcoal: '#313135',
  raisinBlack: '#202023',
  davysGrey: '#575757',
  silverChalice: '#ABABAB',
};

export const textStyles = {
  regular: 'IRANYekan',
  medium: 'IRANYekanMedium',
  bold: 'IRANYekanBold',
  extraBold: 'IRANYekanExtraBoldFaNum',
};
